<script>
  import { Circle3 } from "svelte-loading-spinners";
  import { onMount } from "svelte";
  import AuthService from "../authService.js";
  import EstadoDenuncia from "./EstadoDenuncia.svelte";
  import ComplaintFormService from "../complaintFormService.js";

  let data = null;
  let complaintData = null;

  onMount(async () => {
    const response = await ComplaintFormService.getUserListComplaintAnswers();

    console.log(response);

    if (!response.success) {
      if (response.body.code === 7) {
        AuthService.logout();
      }
    } else {
      complaintData = response.body.complaint_form_answers;
    }
  });

  async function handleShowSate(formAnswerUuid) {
    const response = await ComplaintFormService.getComplaintAnswer(
      formAnswerUuid
    );

    if (response.success) {
      data = response.body;
    }
  }
</script>

<section id="denuncias" class="section mx-5">
  <div class="container">
    <h2 class="text-center font-weight-600 text-uppercase mb-5">
      Mis denuncias / Asistencias legales
    </h2>

    {#if !data}
      {#if !complaintData}
        <div class="d-flex justify-content-center">
          <Circle3
            size="60"
            ballTopLeft="#4843d2"
            ballTopRight="#4843d2"
            ballBottomLeft="#4843d2"
            ballBottomRight="#4843d2"
            unit="px" />
        </div>
      {:else}
        <div class="py-3 px-3 bg-white">
          <table class="table">
            <thead class="thead-dark">
              <tr>
                <th scope="col">#</th>
                <th scope="col">Compañía</th>
                <th scope="col">Fecha</th>
                <th scope="col">Tipo</th>
                <th scope="col">Estado</th>
                <th style="text-align: center" scope="col">Acciones</th>
              </tr>
            </thead>
            <tbody>
              {#each complaintData as formAnswer}
                <tr>
                  <th scope="row">{formAnswer.id}</th>
                  <td>{formAnswer.client.company}</td>
                  <td>{formAnswer.created_dt}</td>
                  <td>{formAnswer.type === 'complaint' ? 'Denuncia' : 'Asistencia Legal'}</td>
                  <td>{(formAnswer.state === 'started' ? 'Iniciada' : (formAnswer.state === 'in_progress' ? 'En Progreso' : 'Finalizada'))}</td>
                  <td style="text-align: center">
                    <i
                      on:click={() => handleShowSate(formAnswer.uuid)}
                      class="fa fa-eye"
                      style="cursor:pointer" />
                  </td>
                </tr>
              {/each}
            </tbody>
          </table>
        </div>
      {/if}
    {:else}
      <div class="d-flex justify-content-end mx-5">
        <div
          class="btn btn-primary rounded-0 shadow-none"
          on:click={() => (data = null)}>
          Volver
        </div>
      </div>

      <EstadoDenuncia {data} {handleShowSate} />
    {/if}

  </div>
</section>
